import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import "./i18n";
import App from "./App.tsx";
import "./index.css";

// Initialise Sentry BEFORE React renders — catches mount errors too
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
